export default {"src":"/_next/static/media/avanti-logo-primary.2502fe4e.svg","height":31,"width":93,"blurWidth":0,"blurHeight":0};